import { useLocation } from 'react-router-dom';
import zh from '../locales/zh.json';
import en from '../locales/en.json';

// Register each new JSON catalog once here; routes and the dropdown read from this list.
export const catalogs = { zh, en };
export const languages = Object.entries(catalogs).map(([code, messages]) => ({
  code,
  htmlLang: messages.meta.htmlLang,
}));
export const locales = languages.map((language) => language.code);

export function getMessages(locale) {
  return catalogs[locale] || catalogs.zh;
}

export function localeFromPath(pathname) {
  const segment = pathname.split('/')[1];
  return locales.includes(segment) ? segment : 'zh';
}

export function hasLocalePrefix(pathname) {
  const segment = pathname.split('/')[1];
  return locales.includes(segment);
}

export function pathWithoutLocale(pathname) {
  if (!hasLocalePrefix(pathname)) return pathname;
  const separator = pathname.indexOf('/', 1);
  return separator === -1 ? '/' : pathname.slice(separator);
}

export function localizedPath(locale, pathname = '/') {
  const path = pathWithoutLocale(pathname);
  return `/${locale}${path === '/' ? '' : path}`;
}

export function useLocale() {
  return localeFromPath(useLocation().pathname);
}

export function useMessages() {
  return getMessages(useLocale());
}
